import React, { useState } from 'react';
import './CalculatorPage.css';

function PlanetaryInfluenceScore() {
  const [dob, setDob] = useState('');
  const [tob, setTob] = useState(''); // Time of Birth
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (dateString, timeString) => {
    // Placeholder for Planetary Influence Score calculation logic
    // This is a highly complex astrological calculation and will be simplified here.
    // A real implementation would require a robust astrological library or API.
    if (!dateString || !timeString) return null;

    const dateParts = dateString.split('/');
    const timeParts = timeString.split(':');

    if (dateParts.length !== 3 || timeParts.length !== 2) {
      return null; // Invalid format
    }

    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10);
    const year = parseInt(dateParts[2], 10);
    const hour = parseInt(timeParts[0], 10);
    const minute = parseInt(timeParts[1], 10);

    if (isNaN(day) || isNaN(month) || isNaN(year) || isNaN(hour) || isNaN(minute) ||
        month < 1 || month > 12 || day < 1 || day > 31 || hour < 0 || hour > 23 || minute < 0 || minute > 59) {
      return null; // Invalid date/time components
    }

    // Very simplified example: sum of digits from date and time
    let score = 0;
    const combinedString = dateString.replace(/\D/g, '') + timeString.replace(/\D/g, '');
    for (let i = 0; i < combinedString.length; i++) {
      score += parseInt(combinedString[i], 10);
    }

    while (score > 9) {
      score = score.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }

    return score;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    const timeRegex = /^\d{2}:\d{2}$/;

    if (!dateRegex.test(dob)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }
    if (!timeRegex.test(tob)) {
      setError('Please enter a valid time in HH:MM format.');
      return;
    }

    const calculated = calculate(dob, tob);
    if (calculated === null) {
      setError('Invalid input. Please check your date and time of birth.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (score) => {
    return `Your Planetary Influence Score is ${score}. This is a placeholder explanation for planetary influence.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Plenetary Influence Score Calculator",
    "description": "Calculate your Planetary Influence Score based on your birth date and time.",
    "url": "https://www.yourwebsite.com/planetary-influence-score",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Planetary Influence Score",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/planetary-influence-score?dob={dob}&tob={tob}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": [
        "required name=dob",
        "required name=tob"
      ]
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Plenetary Influence Score</h1>
      <p className="text-center">Enter your Date and Time of Birth to calculate your Planetary Influence Score.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="dob">Date of Birth (DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob"
            className="form-control"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        <div className="form-group">
          <label htmlFor="tob">Time of Birth (HH:MM - 24hr format):</label>
          <input
            type="text"
            id="tob"
            className="form-control"
            value={tob}
            onChange={(e) => setTob(e.target.value)}
            placeholder="e.g., 14:30"
            maxLength="5"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Calculate Score</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Planetary Influence Score is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default PlanetaryInfluenceScore;
